import { fetchSameOrigin } from '../../Utils';

function deleteOffer(memberId, offerId) {
  return fetchSameOrigin(`/members/${memberId}/member_offers/${offerId}`, 'DELETE')
    .then(_ => new Promise(resolve => {
      window.location.reload();
      resolve();
    }));
}

export default deleteOffer;
